import { FilterName } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { trackRetailersFilterClearClick } from "@faire/web-api--source/events/retailers/click/filterClear";

export const useClearCategoryPageFilters = () => {
  const { clearAllFilters } = useFilterStore([]);

  return () => {
    trackRetailersFilterClearClick(
      FilterName.LOGGED_IN_CATEGORY,
      "no_results_clear_all",
      ""
    );
    clearAllFilters();
  };
};
